<template>
  <v-list class="py-0">
    <template v-for="item in getItems">
      <v-list-item
        :key="item.id"
        :class="[
          'px-0',
          item.status === 'picked' ? {
            'primary lighten-4': item.cid,
            'red lighten-4': !item.cid
          } : ''
        ]">
        <v-row>
          <v-col align-self="center" :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.date }}</v-col>
          <v-col align-self="center" :class="['text-right text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.payee }}</v-col>
          <v-col align-self="center" :class="['py-1 text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">
            <v-menu offset-y v-if="item.status === 'picked'">
              <template v-slot:activator="{ on }">
                <v-btn text
                  v-on="on"
                  color="secondary"
                  :class="[{ caption: $vuetify.breakpoint.mdAndDown }]">{{ item.clientName || (item.clients.length > 1 && '選択する') || item.client }}</v-btn>
              </template>
              <v-list class="py-0">
                <template v-for="jtem in item.clients">
                  <v-list-item :key="jtem.id" @click="select(item, jtem)">
                    <v-list-item-avatar>
                      <v-icon v-if="item.cid === jtem.id" color="secondary">fa-check-circle</v-icon>
                      <v-icon small v-else-if="jtem.type === 'company'">fal fa-building</v-icon>
                      <v-icon small v-else-if="jtem.type === 'client'">fal fa-user</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ jtem.name ? jtem.name.replace(',', ' ') : '' }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider :key="`${jtem.id}_sub_div`"></v-divider>
                </template>
                <v-list-item v-if="!item.clients.length">
                  <v-list-item-content>該当の顧客は登録されていません</v-list-item-content>
                </v-list-item>
                <v-list-item @click="insert(item)">
                  <v-list-item-avatar>
                    <v-icon small>fal fa-plus</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>新規追加する</v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
            <span v-else>{{ item.client }}</span>
          </v-col>
          <v-col align-self="center" :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.item }}</v-col>
          <v-col align-self="center" :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.sum }}</v-col>
          <v-col align-self="center" :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.content }}</v-col>
        </v-row>
      </v-list-item>
      <v-divider :key="`${item.id}_div`"></v-divider>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'authorBbookPreviewLife',
  props: [ 'items' ],
  methods: {
    insert: function (item) {
      this.$emit('emit', {
        action: 'openClientInserter',
        data: item
      })
    },
    select: function (item, client) {
      this.$emit('emit', {
        action: 'selectClient',
        data: { item, client }
      })
    }
  },
  computed: {
    getItems () {
      return (this.$props.items && this.$props.items.length) ? this.$props.items.map(it => {
        const { id, cid, date, payee, sum, content, client, clients, clientName, item, status } = it
        return {
          id,
          cid,
          date: this.$moment(date).format('YYYY/MM/DD'),
          sum: `${sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
          payee: payee,
          client: client,
          clients: clients || [],
          clientName,
          item,
          content,
          status
        }
      }) : []
    }
  }
}
</script>